module.exports = __webpack_public_path__ + "assets/img/tit2.22ed95ff.png";